/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Avatar, IconButton, Pagination, Typography, Box, Tab, ClickAwayListener, MenuItem, ListItemText, Badge, styled, Grow, Popper, Chip, Tooltip } from '@mui/material'
import { MdOutlineModeEdit } from 'react-icons/md'
// import { FiFilter } from 'react-icons/fi'
import CustomSearchField from 'src/Common/ui/searchInput'
import { Button } from 'src/Common/ui/button'
import { AiOutlineCluster } from 'react-icons/ai'
import { IoWarning } from 'react-icons/io5'
import { cn, featValid } from 'src/lib/utils'
import { TabContext, TabList } from '@mui/lab'
import { FiArrowUp, FiArrowDown, FiFilter } from 'react-icons/fi'
import { Checkbox } from 'src/Common/ui/checkbox'
import { useOnboardingStore } from 'src/Containers/Onboarding/Store/OnboardingStore'
import Loading from 'src/Common/ui/Loading'
import EditPencilIcon from 'src/Common/Icon/EditPencilIcon'
import { RxCrossCircled } from 'react-icons/rx'
import { useLocation, useNavigate } from 'react-router'
import * as RoutePaths from '../../../Entities/RoutePath'
import * as XLSX from 'xlsx'
import { BiCopy, BiSolidCopy } from 'react-icons/bi'
import { useCommonStore } from 'src/Common/store/CommonStore'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import AddUserNodeDrawer from 'src/Components/Settings/UserList/AddUserNodeDrawer'
import EditUserNodeDrawer from 'src/Components/Settings/UserList/EditUserNodeDrawer'
import { RiMailSendLine } from 'react-icons/ri'
import { useLoginStore } from 'src/Containers/Auth/Store/Store'
import { UPDATE_USER_MANAGEMENT } from 'src/Entities/Features'

const ArrowBox = styled(Box)(({ theme }) => ({
    position: 'relative',
    backgroundColor: '#fff',
    boxShadow: 'hsl(var(--shadow)) 0px 0px 5px 1px',
    borderRadius: '10px',
    maxWidth: 300,
    '&::before': {
        content: '""',
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: 0,
        height: 0,
        borderTop: '10px solid transparent',
        borderBottom: '10px solid transparent'
    }
}))

const UserList = () => {
    const { rollData, getAllRole } = useCommonStore()
    const { sendInnviteFronOnboarding, sendInnviteFronOnboardingLoading } = useLoginStore()
    const { createOrganizationChart, createOrganizationChartLoading, getOrganizationChart, getOrganizationChartData, getOrganizationChartLoading } = useOnboardingStore()
    const [ page, setPage ] = useState(1)
    const [ search, setSearch ] = useState('')
    const [ activeInActiveTabChange, setActiveInActiveTabChange ] = useState('1')
    const [ sortOrder, setSortOrder ] = useState('asc')
    const [ designationFilter, setDesignationFilter ] = useState('')
    const [ departmentFilter, setDepartmentFilter ] = useState('')
    const [ roleFilter, setRoleFilter ] = useState('')
    const [ designationDropdown, setDesignationDropdown ] = useState(false)
    const [ departmentDropdown, setDepartmentDropdown ] = useState(false)
    const [ roleDropdown, setRoleDropdown ] = useState(false)
    const [ reportToDropdown, setReportToDropdown ] = useState(false)
    const [ reportToFilter, setReportToFilter ] = useState('')
    const [ expandedRow, setExpandedRow ] = useState(null)
    const [ roleData, setRoleData ] = useState([])
    const [ isCopy, setIsCopy ] = useState({ phNumber: false, emailId: false })
    const [ parentNodeValue, setParentNodeValue ] = useState({})
    const [ newNode, setnewNode ] = useState({})
    const [ addState, setAddState ] = useState({ right: false })
    const [ childNodeCount, setChildNodeCount ] = useState(0)
    const [ editState, setEditState ] = useState({ right: false })
    const [ currentNode, setCurrentNode ] = useState({})
    const loginId = localStorage.getItem('userId')
    const [ loading, setLoading ] = useState(false)

    const navigate = useNavigate()
    const location = useLocation()
    useEffect(() => {
        if (location.pathname === '/GRC/settings/user-management/user-list') {
            handleCloseClick()
        }
    }, [navigate])
    const ActiveInActiveTabcheck = activeInActiveTabChange === '1'
    const activeCount = getOrganizationChartData?.filter((filterData, filterIdx) => filterData?.data?.boardMembers === null && filterData?.data?.isActive === true)?.length
    const inActiveCount = getOrganizationChartData?.filter((filterData, filterIdx) => filterData?.data?.boardMembers === null && filterData?.data?.firstName !== null && (filterData?.data?.isActive === false || filterData?.data?.isActive === null))?.length
    const employeeData = getOrganizationChartData?.filter((filterData) => {
        if (ActiveInActiveTabcheck === false) { return filterData?.data?.isActive === null || filterData?.data?.isActive === false }
        return filterData?.data?.isActive === ActiveInActiveTabcheck
    })?.map((mapData, index) => {
        return {
            ...mapData?.data,
            id: index + 1,
            name: mapData?.data?.displayName,
            role: mapData?.data?.role,
            designation: mapData?.data?.designation,
            department: mapData?.data?.department,
            reportTo: mapData?.data?.parentName,
            reportToImage: mapData?.data?.parentProfilePic,
            roleIcon: ''
        }
    })

    const orgId = localStorage.getItem('orgId')
    // const loginId = localStorage.getItem('loginId')

    const Governance = roleData?.filter((filterDt) => filterDt?.roleGroups === 1)?.map((mapDt) => mapDt?.name)
    const Risk = roleData?.filter((filterDt) => filterDt?.roleGroups === 3)?.map((mapDt) => mapDt?.name)
    const Compliance = roleData?.filter((filterDt) => filterDt?.roleGroups === 2)?.map((mapDt) => mapDt?.name)

    useEffect(() => {
        getOrganizationChart(orgId, loginId)
        getAllRole(orgId)
    }, [])

    useEffect(() => {
        if (newNode?.parentName) {
            setParentNodeValue(employeeData.find((findData, fidIdx) => +findData?.userId === +newNode?.parentName))
            setChildNodeCount(employeeData?.filter((filterDt) => Number(filterDt?.reportsTo) === Number(newNode?.parentName))?.length)
        }
    }, [newNode?.parentName])

    useEffect(() => {
        if (rollData?.length > 0) {
            setRoleData(rollData)
        }
    }, [rollData])

    useEffect(() => {
        if (location?.state?.userProfileDetail && location.pathname !== '/GRC/settings/user-management/user-list') {
            setExpandedRow(location?.state?.userProfileDetail)
        } else {
            setExpandedRow(null)
            setIsCopy({})
        }
    }, [location?.state?.userProfileDetail])

    useEffect(() => {
        setExpandedRow(null)
        setIsCopy({ ...isCopy, phNumber: false, emailId: false })
        navigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.SETTINGS.URI + RoutePaths.USER_MANAGEMENT.URI + RoutePaths.USER_LIST.URI)
    }, [search])

    const profileDataExportToCSV = () => {
        const data = paginatedData?.map((mapDt, index) => {
            return {
                S_No: index + 1,
                Name: mapDt?.name,
                Designation: mapDt?.designation || '',
                Department: mapDt?.department,
                Role: mapDt?.role?.join(','),
                Reports_To: mapDt?.reportTo || ''
            }
        })

        const ws = XLSX.utils.json_to_sheet(data)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

        XLSX.writeFile(wb, 'UserDetails.csv')
    }

    const singleUserProfileExportToCSV = () => {
        const data = [
            {
                S_No: 1,
                Full_Name: expandedRow?.fullName || '',
                Role: expandedRow?.role?.join(','),
                Designation: expandedRow?.designation || '',
                Department: expandedRow?.department || '',
                Level: expandedRow?.level || '',
                Email_ID: expandedRow?.emailId || '',
                Phone_Number: `${expandedRow?.phoneCode} ${expandedRow?.phoneNumber}`,
                Duration: `${dayjs(expandedRow?.fromDate).format('MMM DD, YYYY')} - ${expandedRow?.atPresent === true ? 'Present' : dayjs(expandedRow?.to).format('MMM DD, YYYY')}`
            }
        ]

        const ws = XLSX.utils.json_to_sheet(data)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

        XLSX.writeFile(wb, `${expandedRow?.firstName} ${expandedRow?.lastName} UserDetails.csv`)
    }

    // const handleOpenDrawer = (user) => {
    //     setnewNode(user)
    //     setAddState({ ...addState, right: true })
    // }

    const handleEditDrawerOpen = (data) => {
        setEditState({ ...editState, right: true })
        setCurrentNode(data)
    }

    const handleFormSubmit = (newData) => {
        setLoading(true)
        const newNode = [{
            empId: 0,
            firstName: newData?.firstName || '',
            middleName: newData?.middleName || '',
            lastName: newData?.lastName || '',
            displayName: newData?.displayName || '',
            designationId: typeof newData?.designation === 'number' ? newData.designation : 0,
            designation: typeof newData?.designation === 'string' ? newData.designation : '',
            level: parentNodeValue?.level ? parentNodeValue?.level + 1 : 1,
            departmentId: typeof newData?.department === 'number' ? newData?.department : 0,
            department: typeof newData?.department === 'string' ? newData?.department : '',
            emailId: newData?.emailId || '',
            phoneNo: newData?.phoneNumber || '',
            role: newData?.role || [],
            fromDate: newData?.fromDate?.toISOString() || new Date().toISOString(),
            // toDate: newData?.toDate?.toISOString() || new Date().toISOString(),
            atPresent: newData?.atPresent || true,
            profilePic: newData?.profilePic || '',
            reportsTo: parentNodeValue?.id || 0,
            isActive: newData?.isActive || false,
            status: 1,
            x: parentNodeValue?.id ? (childNodeCount === 0 ? 0 : (childNodeCount === 1 ? parentNodeValue?.pos?.x + 250 : 2 * parentNodeValue?.pos?.x)) : 0,
            y: parentNodeValue?.id ? parentNodeValue?.pos?.y + 250 : 0
        }]
        createOrganizationChart({ chartRequests: newNode }, loginId, orgId)
            .then((response) => {
                if (response && response.data) {
                    getOrganizationChart(orgId, 1)
                    toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>Employee added successfully</p></p>, {
                        position: 'top-right', theme: 'light'
                    })
                    setAddState({ ...addState, right: false })
                    setLoading(false)
                } else {
                    console.error('Invalid response structure:', response)
                    toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>Error in adding employee try again!</p></p>, {
                        position: 'top-right', theme: 'light'
                    })
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.error('Error posting organization chart data:', err)
                setLoading(false)
            })
        setnewNode({})
    }

    const onEdit = (data, allRoleData, allDesData, allDepData) => {
        setLoading(true)
        const designation = typeof data?.designation === 'string' ? allDesData?.find(findDt => findDt?.name?.toLowerCase() === data?.designation?.toLowerCase())?.id || data?.designation : data?.designation
        const department = typeof data?.department === 'string' ? allDepData?.find(findDt => findDt?.name?.toLowerCase() === data?.department?.toLowerCase())?.id || data?.department : data?.department
        const newNode = [{
            empId: data?.empId || 0,
            firstName: !data.isVacant ? data?.firstName : '',
            middleName: !data.isVacant ? data?.middleName || '' : '',
            lastName: !data.isVacant ? data?.lastName : '',
            displayName: !data.isVacant ? data?.displayName : '',
            designationId: typeof designation === 'number' ? designation : 0,
            designation: typeof designation === 'string' ? designation : '',
            level: data?.level,
            departmentId: typeof department === 'number' ? department : 0,
            department: typeof department === 'string' ? department : '',
            emailId: !data.isVacant ? data?.emailId : '',
            phoneNo: !data.isVacant ? data?.phoneNumber : '',
            role: data?.role?.map((roleName, index) => {
                const role = allRoleData?.find(item => item.name === roleName)
                return role ? role?.id : null
            })?.filter(roleId => roleId !== null),
            status: 1,
            isActive: data?.isActive || false,
            fromDate: typeof data?.fromDate === 'object' ? data?.fromDate?.toISOString() : data?.fromDate,
            // toDate: typeof data?.toDate === 'object' ? data?.toDate?.toISOString() : data?.toDate,
            atPresent: data?.atPresent || true,
            profilePic: data?.profilePic || '',
            reportsTo: data?.reportsTo || 0,
            x: data?.pos?.x,
            y: data?.pos?.y
        }]
        const chartRequestFormData = new FormData()

        const appendFormDataOrgChart = (formData, data, parentKey = '') => {
            if (data && typeof data === 'object' && !Array.isArray(data)) {
                Object.keys(data).forEach(key => {
                    const newKey = parentKey ? `${parentKey}[${key}]` : key
                    appendFormDataOrgChart(formData, data[key], newKey)
                })
            } else if (Array.isArray(data)) {
                data.forEach((item, index) => {
                    const newKey = `${parentKey}[${index}]`
                    appendFormDataOrgChart(formData, item, newKey)
                })
            } else {
                formData.append(parentKey, data)
            }
        }

        newNode.forEach((obj, index) => {
            Object.keys(obj).forEach(key => {
                const newKey = `chartRequests[${index}][${key}]`
                appendFormDataOrgChart(chartRequestFormData, obj[key], newKey)
            })
        })
        createOrganizationChart(chartRequestFormData, 1, orgId)
            .then((response) => {
                if (response && response.data) {
                    getOrganizationChart(orgId, 1)
                    toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>Employee details updated successfully</p></p>, {
                        position: 'top-right', theme: 'light'
                    })
                    setEditState({ ...editState, right: false })
                    setLoading(false)
                } else {
                    console.error('Invalid response structure:', response)
                    toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>Error in updating employee details try again!</p></p>, {
                        position: 'top-right', hideProgressBar: true, theme: 'light'
                    })
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.error('Error posting organization chart data:', err)
                setLoading(false)
            })
    }

    const handleCloseClick = () => {
        setExpandedRow(null)
    }

    const handleNameClick = (item) => {
        setIsCopy({ ...isCopy, phNumber: false, emailId: false })
        navigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.SETTINGS.URI + RoutePaths.USER_MANAGEMENT.URI + RoutePaths.USER_LIST.URI + RoutePaths.USER_LIST.PROFILE, { state: { userProfileDetail: item } })
    }

    const handlePageChange = (event, value) => {
        setPage(value)
    }

    const handleSearch = (event) => {
        setSearch(event)
    }

    const handleSort = () => {
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
    }

    const handleTabChange = (event, newValue) => {
        setActiveInActiveTabChange(newValue)
        setSearch('')
    }

    const toggleDropdown = (dropdownSetter) => {
        dropdownSetter((prev) => !prev)
    }

    const handleFilterChange = (value, setFilter, currentFilter) => {
        const newFilter = currentFilter.includes(value)
            ? currentFilter.filter(item => item !== value)
            : [ ...currentFilter, value ]
        setFilter(newFilter)
    }

    const [ anchorEl, setAnchorEl ] = useState(null)
    const [ rolePopper, setRolePopper ] = useState([])

    const handleMouseEnter = (event, roles) => {
        setAnchorEl(event.currentTarget)
        setRolePopper(roles)
    }

    const handlePopoverClose = () => {
        setAnchorEl(null)
        setRolePopper([])
    }

    const handleNavigateOrgChart = () => {
        navigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.GOVERNANCE.ORG_CHART)
    }

    const filteredData = employeeData
        .filter((row) => {
            return row.name?.toLowerCase().includes(search.toLowerCase()) &&
            (designationFilter.length === 0 || designationFilter.includes(row.designation)) &&
            (departmentFilter.length === 0 || departmentFilter.includes(row.department)) &&
            (roleFilter.length === 0 || roleFilter.some((role) => row.role.includes(role))) &&
            (reportToFilter.length === 0 || reportToFilter.includes(row.reportTo))
        }
        )
        .sort((a, b) => {
            const dateA = new Date(a.modifiedDate)
            const dateB = new Date(b.modifiedDate)
            return sortOrder === 'dec' ? dateA - dateB : dateB - dateA
        })

    const itemsPerPage = 8
    const paginatedData = filteredData.slice((page - 1) * itemsPerPage, page * itemsPerPage)
    const totalPages = Math.ceil(filteredData.length / itemsPerPage)
    const features = JSON.parse(localStorage.getItem('features'))

    return (
        <div className='w-[100%] h-[100%] !overflow-auto p-[20px]'>
            <Loading isLoading={getOrganizationChartLoading || createOrganizationChartLoading || sendInnviteFronOnboardingLoading} />
            <div className='bg-card'>
                <TabContext value={activeInActiveTabChange}>
                    <Box sx={{ borderBottom: 2 }} className='text-primary-foreground'>
                        <TabList
                            className='normal-case'
                            onChange={handleTabChange}
                            sx={{
                                '& .MuiTabs-indicator': { background: 'hsl(var(--primary))' },
                                display: 'flex',
                                alignItems: 'center',
                                textTransform: 'none'
                            }}
                        >
                            <Tab label="Active" className='!text-h4' value="1" sx={{ '&.Mui-selected': { color: 'hsl(var(--muted))', textTransform: 'none' }, textTransform: 'none' }} />
                            <div style={{ color: 'hsl(var(--primary))', backgroundColor: 'hsl(var(--primary-foreground))', borderRadius: '50%', marginTop: '15px', marginLeft: '-12px', width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {activeCount}
                            </div>
                            <Tab label="In Active" className='!text-h4' value="2" sx={{ '&.Mui-selected': { color: 'hsl(var(--muted))', textTransform: 'none' }, textTransform: 'none' }} />
                            <div style={{ color: 'hsl(var(--primary))', backgroundColor: 'hsl(var(--primary-foreground))', borderRadius: '50%', marginTop: '15px', marginLeft: '-12px', width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {inActiveCount}
                            </div>
                        </TabList>
                    </Box>
                    <Box className='py-[15px] flex flex-row justify-between items-center'>
                        <div className="mt-2 ml-4">
                            <CustomSearchField
                                className="w-[100%] h-[100%] text-[#333]"
                                value={search}
                                setSearch={setSearch}
                                onValueChange={handleSearch}
                                // setSelectedData={handleSelectNav}
                            />
                        </div>
                        <div className="ml-auto space-x-5 mr-4 flex items-center">
                            <Tooltip title="Download User List" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                <Button onClick={profileDataExportToCSV} style={{ height: '35px', width: '35px' }} variant="outline" className="grc-btn-one">
                                    <img src={'/Common/Icon/Download.svg'} size={18} />
                                </Button>
                            </Tooltip>
                            <Tooltip title="View Org chart" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                <Button style={{ height: '35px', width: '35px' }} onClick={handleNavigateOrgChart} variant="outline" className="grc-btn-one">
                                    <AiOutlineCluster size={26} />
                                </Button>
                            </Tooltip>
                            {/* {featValid(features, CREATE_USER_MANAGEMENT) && <Button style={{ height: '35px', width: '35px' }} variant="outline" className="grc-btn-one" onClick={() => handleOpenDrawer()}>
                                <IoAdd color='hsl(var(--primary))' style={{ cursor: 'pointer', borderRadius: '3px', height: '35px', width: '35px' }} />
                            </Button>} */}
                        </div>
                    </Box>
                </TabContext>
            </div>
            <div className={`flex flex-row w-[100%] ${expandedRow ? 'h-[80%]' : 'h-[80%]'} bg-card overflow-auto`}>
                <div className={`${expandedRow ? 'w-[40%]' : 'w-[100%]'} flex flex-col h-[100%] ${expandedRow ? 'table-header-row-one' : ''}`} >
                    <TableContainer className='global-table' sx={{ flex: '1', width: '100%', height: expandedRow ? '92%' : '100%' }}>
                        <Table className=''>
                            <TableHead className='h-[10%]'>
                                <TableRow style={{ height: '100%', backgroundColor: 'hsl(var(--primary-foreground))' }}>
                                    <TableCell style={{ color: 'hsl(var(--primary))', padding: '15px', width: '5%', border: '1px solid transparent', borderRadius: '10px 0px 0px 0px' }}>
                                        <Tooltip title="S.No" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>#</Tooltip>
                                    </TableCell>
                                    <TableCell align='center' onClick={handleSort} style={{ color: 'hsl(var(--primary))', padding: '15px', cursor: 'pointer', display: 'flex', flexDirection: 'row' }}>
                                        Name
                                        <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                            <IconButton size="small">
                                                {sortOrder === 'asc' ? <FiArrowUp fontSize="medium" color='hsl(var(--primary))' /> : <FiArrowDown fontSize="medium" color='hsl(var(--primary))' />}
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell align='center' style={{ color: 'hsl(var(--primary))', padding: '15px' }}>
                                        Designation
                                        <Tooltip title="Filter" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                            <IconButton size="small" onClick={() => toggleDropdown(setDesignationDropdown)} >
                                                <FiFilter color='hsl(var(--primary))' fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        {designationDropdown && (
                                            <ClickAwayListener onClickAway={() => setDesignationDropdown(false)}>
                                                <div style={{ height: '200px', overflow: 'auto', borderRadius: '10px', border: '1px solid hsl(var(--primary-thick-foreground))', position: 'absolute', background: 'white', zIndex: 1 }}>
                                                    {Array.from(new Set(employeeData.map(emp => emp.designation))).map(designation => (
                                                        <MenuItem style={{ borderBottom: '1px solid hsl(var(--primary-thick-foreground))' }} key={designation}>
                                                            <Checkbox
                                                                checked={designationFilter.includes(designation)}
                                                                onCheckedChange={() => handleFilterChange(designation, setDesignationFilter, designationFilter)}
                                                            />
                                                            <ListItemText sx={{ paddingLeft: '10px' }} primary={designation} />
                                                        </MenuItem>
                                                    ))}
                                                    <MenuItem style={{ borderBottom: '1px solid hsl(var(--primary-thick-foreground))' }} onClick={() => setDesignationFilter([])}>

                                                        <ListItemText sx={{ paddingLeft: '10px' }} primary={'Clear All'} />
                                                    </MenuItem>
                                                </div>
                                            </ClickAwayListener>
                                        )}
                                    </TableCell>
                                    {!expandedRow && <TableCell align='center' style={{ color: 'hsl(var(--primary))', padding: '15px' }}>
                                        Department
                                        <Tooltip title="Filter" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                            <IconButton size="small" onClick={() => toggleDropdown(setDepartmentDropdown)} >
                                                <FiFilter color='hsl(var(--primary))' fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        {departmentDropdown && (
                                            <ClickAwayListener onClickAway={() => setDepartmentDropdown(false)}>
                                                <div style={{ height: '200px', overflow: 'auto', borderRadius: '10px', border: '1px solid hsl(var(--primary-thick-foreground))', position: 'absolute', background: 'white', zIndex: 1 }}>
                                                    {Array.from(new Set(employeeData.map(emp => emp.department))).map(department => (
                                                        <MenuItem style={{ borderBottom: '1px solid hsl(var(--primary-thick-foreground))' }} key={department}>
                                                            <Checkbox
                                                                checked={departmentFilter.includes(department)}
                                                                onCheckedChange={() => handleFilterChange(department, setDepartmentFilter, departmentFilter)}
                                                            />
                                                            <ListItemText sx={{ paddingLeft: '10px' }} primary={department} />
                                                        </MenuItem>
                                                    ))}
                                                </div>
                                            </ClickAwayListener>
                                        )}
                                    </TableCell>}
                                    {!expandedRow && <TableCell align='center' style={{ color: 'hsl(var(--primary))', padding: '15px' }}>
                                        Role
                                        <Tooltip title="Filter" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                            <IconButton size="small">
                                                <FiFilter color='hsl(var(--primary))' fontSize="small" onClick={() => toggleDropdown(setRoleDropdown)} />
                                            </IconButton>
                                        </Tooltip>
                                        {roleDropdown && employeeData.map(emp => emp.role).length > 0 && (
                                            <ClickAwayListener onClickAway={() => setRoleDropdown(false)}>
                                                <div style={{ height: '200px', overflow: 'auto', borderRadius: '10px', border: '1px solid hsl(var(--primary-thick-foreground))', position: 'absolute', background: 'white', zIndex: 1 }}>
                                                    {Array.from(new Set([...new Set(employeeData.map(emp => emp.role).flat())])).map((role, i) => {
                                                        return (
                                                            <MenuItem style={{ borderBottom: '1px solid hsl(var(--primary-thick-foreground))' }} key={role}>
                                                                <Checkbox
                                                                    checked={roleFilter.includes(role)}
                                                                    onCheckedChange={() => handleFilterChange(role, setRoleFilter, roleFilter)}
                                                                />
                                                                <ListItemText sx={{ paddingLeft: '10px' }} primary={role} />
                                                            </MenuItem>
                                                        )
                                                    })}
                                                </div>
                                            </ClickAwayListener>
                                        )}
                                    </TableCell>}
                                    {!expandedRow && <TableCell align='center' style={{ color: 'hsl(var(--primary))', padding: '15px' }} >
                                        Report To
                                        <Tooltip title="Filter" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                            <IconButton size="small" onClick={() => toggleDropdown(setReportToDropdown)} >
                                                <FiFilter color='hsl(var(--primary))' fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        {reportToDropdown && employeeData.map(emp => emp.reportTo).filter(ele => ele !== null).length > 0 && (
                                            <ClickAwayListener onClickAway={() => setReportToDropdown(false)}>
                                                <div style={{ height: '200px', overflow: 'auto', borderRadius: '10px', border: '1px solid hsl(var(--primary-thick-foreground))', position: 'absolute', background: 'white', zIndex: 1 }}>
                                                    {Array.from(new Set(employeeData.map(emp => emp.reportTo))).filter(ele => ele !== null).map(reportTo => (
                                                        <MenuItem style={{ borderBottom: '1px solid hsl(var(--primary-thick-foreground))' }} key={reportTo}>
                                                            <Checkbox
                                                                checked={reportToFilter.includes(reportTo)}
                                                                onCheckedChange={() => handleFilterChange(reportTo, setReportToFilter, reportToFilter)}
                                                            />
                                                            <ListItemText sx={{ paddingLeft: '10px' }} primary={reportTo} />
                                                        </MenuItem>
                                                    ))}
                                                </div>
                                            </ClickAwayListener>
                                        )}
                                    </TableCell>}
                                    {!expandedRow && <TableCell sx={{ color: 'hsl(var(--primary))', padding: '15px', border: '1px solid transparent' }} />}
                                    {!expandedRow && <TableCell sx={{ color: 'hsl(var(--primary))', padding: '15px', border: '1px solid transparent', borderRadius: '0px 10px 0px 0px' }} />}
                                </TableRow>
                            </TableHead>
                            <TableBody className='h-[100%] overflow-auto'>
                                {paginatedData.length > 0
                                    ? paginatedData.map((employee, index) => {
                                        const roleCount = employee?.role?.length - 1
                                        return (
                                            <TableRow key={employee.id} hover>
                                                <TableCell style={{ padding: '7px', textAlign: 'center' }}><p className='flex flex-col justify-center items-center rounded-[50%] text-primary w-[30px] h-[30px] bg-primary-foreground'>{(page - 1) * itemsPerPage + index + 1}</p></TableCell>
                                                <TableCell style={{ padding: '7px', cursor: 'pointer' }} onClick={() => handleNameClick(employee)} >
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Avatar alt={employee.name} src={employee?.profilePic ? `data:${employee?.profilePic?.contentType};base64, ${employee?.profilePic?.file}` : employee?.name} />
                                                        <span style={{ marginLeft: '10px' }}>{employee.name}</span>
                                                    </div>
                                                </TableCell>
                                                <TableCell align='center' style={{ padding: '7px' }} >{employee.designation}</TableCell>
                                                {!expandedRow && <TableCell align='center' style={{ padding: '7px' }} >{employee.department}</TableCell>}
                                                {!expandedRow && <TableCell align='center' style={{ padding: '7px' }} onMouseEnter={(event) => handleMouseEnter(event, employee.role)} onMouseLeave={handlePopoverClose} >
                                                    {employee.role[0]}
                                                    {roleCount > 0 && <Badge
                                                        badgeContent={'+' + roleCount}
                                                        style={{ right: '-11px', top: '-11px', zIndex: 0 }}
                                                        anchorOrigin={{
                                                            vertical: 'top',
                                                            horizontal: 'right'
                                                        }}
                                                    >
                                                    </Badge>}
                                                    {rolePopper.length > 1 && <Popper
                                                        open={Boolean(anchorEl)}
                                                        anchorEl={anchorEl}
                                                        sx={{ minWidth: 200 }}
                                                        placement="right-start"
                                                        modifiers={[
                                                            {
                                                                name: 'offset',
                                                                options: {
                                                                    offset: [ 0, 10 ]
                                                                }
                                                            }
                                                        ]}
                                                        transition
                                                    >
                                                        {({ TransitionProps }) => (
                                                            <Grow {...TransitionProps} timeout={350}>
                                                                <ArrowBox sx={{ }}>
                                                                    {rolePopper?.slice(1).map((role, index) => (
                                                                        <div style={{ borderBottom: '1px solid hsl(var(--primary-foreground))', color: 'hsl(var(--primary))', padding: '10px' }} key={index}>{role}</div>
                                                                    ))}
                                                                </ArrowBox>
                                                            </Grow>
                                                        )}
                                                    </Popper>}
                                                </TableCell>}
                                                {!expandedRow && <TableCell align='center' style={{ padding: '7px' }} >
                                                    {employee.reportTo
                                                        ? (
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <Avatar alt={employee.reportTo} src={employee.reportToImage ? `data:${employee?.reportToImage?.contentType};base64, ${employee?.reportToImage?.file}` : employee?.reportsTo} />
                                                                <span className='ml-[10px] flex flex-col justify-center items-center'>{employee.reportTo || '-'}</span>
                                                            </div>
                                                        )
                                                        : <div className='text-muted'>-</div>}
                                                </TableCell>}
                                                {!expandedRow && activeInActiveTabChange === '2' && <TableCell style={{ padding: '7px' }}>
                                                    <Tooltip title="Send Email" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                        <IconButton onClick={() => {
                                                            sendInnviteFronOnboarding(orgId, employee?.emailId)
                                                                .then((res) => {
                                                                    if (res.data) {
                                                                        toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>Invite has sent successfully.</p></p>, {
                                                                            position: 'top-right',

                                                                            theme: 'light'
                                                                        })
                                                                    } else {
                                                                        toast.error(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>Failed to send OTP. Please try again later.</p></p>, {
                                                                            position: 'top-right',

                                                                            theme: 'light'
                                                                        })
                                                                    }
                                                                })
                                                                .catch((err) => {
                                                                    console.warn(err)
                                                                    toast.error(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>Failed to send OTP. Please try again later.</p></p>, {
                                                                        position: 'top-right',

                                                                        theme: 'light'
                                                                    })
                                                                })
                                                        }}>
                                                            <RiMailSendLine color='hsl(var(--primary))' />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>}
                                                {!expandedRow && featValid(features, UPDATE_USER_MANAGEMENT) && <TableCell style={{ padding: '7px' }}>
                                                    <Tooltip title="Edit User" placement="right" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                        <IconButton onClick={() => handleEditDrawerOpen(employee)}>
                                                            <MdOutlineModeEdit color='hsl(var(--primary))' />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>}
                                            </TableRow>
                                        )
                                    })
                                    : (<TableRow>
                                        <TableCell colSpan={8} align='center'>{'No Records Found'}</TableCell>
                                    </TableRow>)}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {expandedRow && paginatedData.length > 0 && <div className={cn('border-t-2 border-t-primary-foreground flex flex-row items-center justify-between py-4 pr-[20px] w-[100%] mb-auto mt-auto')}>
                        <Typography className="text-muted !text-h4">
                            Showing data {((page - 1) * itemsPerPage) + 1} to {Math.min(page * itemsPerPage, filteredData.length)} of {filteredData.length} entries
                        </Typography>
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={handlePageChange}
                            color="primary"
                            shape="rounded"
                            variant="outlined"
                        />
                    </div>}
                    {!expandedRow && paginatedData.length > 0 && <div className={cn('py-4 border-t-2 border-t-primary-foreground flex flex-row items-center justify-between static pr-[20px] w-[100%]')}>
                        <Typography className="text-muted !text-h4">
                            Showing data {((page - 1) * itemsPerPage) + 1} to {Math.min(page * itemsPerPage, filteredData.length)} of {filteredData.length} entries
                        </Typography>
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={handlePageChange}
                            color="primary"
                            shape="rounded"
                            variant="outlined"
                        />
                    </div>}
                </div>
                {expandedRow && (
                    <div className={`w-[60%] h-[100%] border-l-2 border-primary-foreground ${expandedRow ? 'table-header-row-two' : ''}`} >
                        <TableContainer className='h-[100%] w-[100%]' >
                            <Table className='w-[100%] h-[100%]' >
                                <TableHead className='w-[100%] h-[10%]' >
                                    <TableRow style={{ backgroundColor: 'hsl(var(--primary-foreground))' }}>
                                        <TableCell style={{ color: 'hsl(var(--primary))', padding: '10px', border: '1px solid transparent', borderRadius: '0px 10px 0px 0px' }}>
                                            <Box className='flex flex-row justify-end items-center'>
                                                <div className="ml-auto space-x-5 mr-4 flex items-center">
                                                    <Tooltip title="Download User Details" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                        <Button style={{ height: '35px', width: '35px', border: 'none' }} variant="outline" className="grc-btn-one" onClick={() => { singleUserProfileExportToCSV() } }>
                                                            <img src={'/Common/Icon/Download.svg'} size={18} />
                                                        </Button>
                                                    </Tooltip>
                                                    {featValid(features, UPDATE_USER_MANAGEMENT) &&
                                                    <Tooltip title="Edit User" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                        <Button style={{ height: '35px', width: '35px', border: 'none' }} variant="outline" className="grc-btn-one" onClick={() => handleEditDrawerOpen(expandedRow)}>
                                                            <EditPencilIcon size={20} />
                                                        </Button></Tooltip>}
                                                    <Tooltip title="Close" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                        <Button style={{ height: '35px', width: '35px', border: 'none' }} variant="outline" className="grc-btn-one" onClick={() => handleCloseClick()}>
                                                            <RxCrossCircled color='hsl(var(--primary))' style={{ cursor: 'pointer', borderRadius: '3px', height: '35px', width: '35px' }} />
                                                        </Button>
                                                    </Tooltip>

                                                </div>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className='w-[100%] h-[90%]'>
                                    <TableRow className='w-[100%] h-[100%]'>
                                        <TableCell className='w-[100%] h-[100%]' >
                                            <div className='w-[100%] h-[100%]' >
                                                <div className='flex flex-row items-center mb-4'>
                                                    <Avatar sx={{ width: 60, height: 60 }} src={expandedRow?.profilePic ? `data:${expandedRow?.profilePic?.contentType};base64, ${expandedRow?.profilePic?.file}` : expandedRow?.name} alt={expandedRow?.name} />
                                                    <div className='flex min-h-[60px] max-h-[100px] flex-col justify-between ml-4' >
                                                        <div className="flex flex-row">
                                                            <p className='text-[18px] text-primary font-semibold'>{expandedRow?.displayName}</p>
                                                            <div className="ml-3">
                                                                <Chip label={expandedRow.isActive ? 'Active' : 'In Active'} style={{ backgroundColor: expandedRow.isActive ? 'hsl(var(--primary))' : 'hsl(var(--Risk))', color: 'white', height: '20px' }}/>
                                                            </div>
                                                        </div>
                                                        <p className='flex flex-row items-center text-primary font-medium flex-wrap' ><span className='mr-[10px]'>Role </span>{expandedRow?.role?.map((mapDt, ind) => {
                                                            const checkRoleCategory = (roleDt) => {
                                                                if (Governance?.includes(roleDt)) {
                                                                    return 'Governance'
                                                                }
                                                                if (Risk?.includes(roleDt)) {
                                                                    return 'Risk'
                                                                }
                                                                if (Compliance?.includes(roleDt)) {
                                                                    return 'Compliance'
                                                                }
                                                            }
                                                            return <Chip style={{ height: '25px', color: 'hsl(var(--card))', backgroundColor: `hsl(var(--${checkRoleCategory(mapDt)}))`, marginRight: '5px' }} key={ind} label={mapDt} />
                                                        })}</p>
                                                    </div>
                                                </div>
                                                <div className='w-[100%] h-[50%]'>
                                                    <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                                                        <Box gridColumn="span 12" >
                                                            <p className='text-[18px] text-primary font-semibold py-2'>More Info </p>
                                                        </Box>
                                                        <Box gridColumn="span 6">
                                                            <div className='flex flex-row py-2'>
                                                                <p className='text-[16px] w-[130px] text-primary font-semibold'>Full Name </p>
                                                                <p className='ml-[5px] text-[16px] text-muted'>{expandedRow?.firstName + ' ' + expandedRow?.lastName }</p>
                                                            </div>
                                                        </Box>
                                                        <Box gridColumn="span 6">
                                                            <div className='flex flex-row py-2'>
                                                                <p className='text-[16px] w-[130px] text-primary font-semibold'>Designation </p>
                                                                <p className='ml-[5px] text-[16px] text-muted'>{expandedRow?.designation}</p>
                                                            </div>
                                                        </Box>
                                                        <Box gridColumn="span 6">
                                                            <div className='flex flex-row py-2'>
                                                                <p className='text-[16px] w-[130px] text-primary font-semibold'>Department </p>
                                                                <p className='ml-[5px] text-[16px] text-muted'>{expandedRow?.department}</p>
                                                            </div>
                                                        </Box>
                                                        <Box gridColumn="span 6">
                                                            <div className='flex flex-row py-2'>
                                                                <p className='text-[16px] w-[130px] text-primary font-semibold'>Level </p>
                                                                <p className='ml-[5px] text-[16px] text-muted'>{expandedRow?.level?.toString().padStart(2, '0')}</p>
                                                            </div>
                                                        </Box>
                                                        <Box gridColumn="span 6">
                                                            <div className='flex flex-row py-2 items-center'>
                                                                <p className='text-[16px] w-[130px] text-primary font-semibold'>Email ID </p>
                                                                <p className={cn(expandedRow?.emailId?.length >= 25 && 'w-[60%] break-words text-wrap', 'ml-[5px] text-[16px] text-muted')}>{expandedRow?.emailId}</p>
                                                                {!isCopy?.emailId
                                                                    ? <Tooltip title="Copy EmailID" placement="right" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                                        <div> <BiCopy color='hsl(var(--primary))' onClick={() =>
                                                                            navigator.clipboard.writeText(expandedRow?.emailId)
                                                                                .then((data) => {
                                                                                    setIsCopy({ ...isCopy, emailId: true })
                                                                                    toast(<p className='w-[100%] flex flex-row justify-evenly items-center' ><BiSolidCopy color='hsl(var(--primary))'/><p>Email Id is Copied to clipboard</p></p>, {
                                                                                        position: 'top-right',
                                                                                        hideProgressBar: true,
                                                                                        theme: 'light'
                                                                                    })
                                                                                })
                                                                        } className='ml-[10px] cursor-pointer' />
                                                                        </div> </Tooltip>
                                                                    : <BiSolidCopy color='hsl(var(--primary))' onClick={() =>
                                                                        navigator.clipboard.writeText(expandedRow?.emailId)
                                                                            .then((data) => {
                                                                                setIsCopy({ ...isCopy, emailId: true })
                                                                                toast(<p className='w-[100%] flex flex-row justify-evenly items-center' ><BiSolidCopy color='hsl(var(--primary))'/><p>Email Id is Copied to clipboard</p></p>, {
                                                                                    position: 'top-right',
                                                                                    hideProgressBar: true,
                                                                                    theme: 'light'
                                                                                })
                                                                            })
                                                                    } className='ml-[10px] cursor-pointer' />}
                                                            </div>
                                                        </Box>
                                                        <Box gridColumn="span 6">
                                                            <div className='flex flex-row py-2 items-center'>
                                                                <p className='text-[16px] w-[130px] text-primary font-semibold'>Phone Number </p>
                                                                <p className='ml-[5px] text-[16px] text-muted'>{expandedRow?.phoneNumber}</p>
                                                                {
                                                                    !isCopy?.phNumber
                                                                        ? <Tooltip title="Copy Phone Number" placement="right" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                                            <div><BiCopy color='hsl(var(--primary))' onClick={() =>
                                                                                navigator.clipboard.writeText(expandedRow?.phoneNumber)
                                                                                    .then((data) => {
                                                                                        setIsCopy({ ...isCopy, phNumber: true })
                                                                                        toast(<p className='w-[100%] flex flex-row justify-evenly items-center' ><BiSolidCopy color='hsl(var(--primary))'/><p>Phone Number is Copied to clipboard</p></p>, {
                                                                                            position: 'top-right',
                                                                                            hideProgressBar: true,
                                                                                            theme: 'light'
                                                                                        })
                                                                                    })
                                                                            } className='ml-[10px] cursor-pointer' />
                                                                            </div></Tooltip>
                                                                        : <BiSolidCopy color='hsl(var(--primary))' onClick={() =>
                                                                            navigator.clipboard.writeText(expandedRow?.phoneNumber)
                                                                                .then((data) => {
                                                                                    setIsCopy({ ...isCopy, phNumber: true })
                                                                                    toast(<p className='w-[100%] flex flex-row justify-evenly items-center' ><BiSolidCopy color='hsl(var(--primary))'/><p>Phone Number is Copied to clipboard</p></p>, {
                                                                                        position: 'top-right',
                                                                                        hideProgressBar: true,
                                                                                        theme: 'light'
                                                                                    })
                                                                                })
                                                                        }
                                                                        className='ml-[10px] cursor-pointer' />}
                                                            </div>
                                                        </Box>
                                                        <Box gridColumn="span 6">
                                                            <div className='flex flex-row py-2'>
                                                                <p className='text-[16px] w-[130px] text-primary font-semibold'>Effective From </p>
                                                                <p className='ml-[5px] text-[16px] text-muted'>{`${dayjs(expandedRow?.fromDate).format('MMM DD, YYYY')} - ${expandedRow?.atPresent === true ? 'Till Date' : dayjs(expandedRow?.to).format('MMM DD, YYYY')}`}</p>
                                                            </div>
                                                        </Box>
                                                    </Box>
                                                </div>
                                                {expandedRow?.parentRole?.length > 0 && <div className='w-[14%]' >
                                                    <p className='text-[15px] text-primary font-bold pt-7 pb-3'>Reports to </p>
                                                </div>}
                                                {expandedRow?.parentRole?.length > 0 && <div className='flex w-[83%] flex-row items-center py-2'>
                                                    <div className='w-[8%]'>
                                                        <Avatar src={expandedRow?.parentProfilePic ? `data:${expandedRow?.parentProfilePic?.contentType};base64,${expandedRow?.parentProfilePic?.file}` : expandedRow?.parentName} style={{ width: '40px', height: '40px', marginRight: '1rem' }} />
                                                    </div>
                                                    <div className='flex w-[20%] flex-col justify-between' >
                                                        <p className='w-[100%] text-[17px] text-primary font-semibold'>{expandedRow?.parentName || <div className='flex flex-row justify-center items-center'><IoWarning className='mr-[5px] h-[20px] w-[20px]' color='hsl(var(--danger))' /><p className='text-danger'>Vacant</p></div>}</p>
                                                        <p className='w-[100%] text-[13px]'>{expandedRow?.parentDesignation}</p>
                                                    </div>
                                                    <div className='flex w-[73%] flex-col justify-center' >
                                                        <p className='flex flex-row w-[100%] items-center text-[16px] text-primary font-semibold' ><span className='w-[10%] mr-[10px]'>Role </span><div className='w-[90%]'>{expandedRow?.role?.map((mapDt, ind) => {
                                                            const checkRoleCategory = (roleDt) => {
                                                                if (Governance?.includes(roleDt)) {
                                                                    return 'Governance'
                                                                }
                                                                if (Risk?.includes(roleDt)) {
                                                                    return 'Risk'
                                                                }
                                                                if (Compliance?.includes(roleDt)) {
                                                                    return 'Compliance'
                                                                }
                                                            }
                                                            return <Chip style={{ height: '25px', marginBottom: '4px', color: 'hsl(var(--card))', backgroundColor: `hsl(var(--${checkRoleCategory(mapDt)}))`, marginRight: '5px' }} key={ind} label={mapDt} />
                                                        })}</div></p>
                                                    </div>
                                                </div>}
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>)}
            </div>
            <AddUserNodeDrawer
                // nodes={nodes}
                newNode={newNode}
                setnewNode={setnewNode}
                parentNodeValue={parentNodeValue}
                // setCurrentNode={setCurrentNode}
                addState={addState}
                // childNodeCount={childNodeCount}
                onAdd={handleFormSubmit}
                setAddState={setAddState}
                loading={loading}
            />
            <EditUserNodeDrawer
                nodes={employeeData}
                currentNode={currentNode}
                setCurrentNode={setCurrentNode}
                editState={editState}
                onEdit={onEdit}
                setEditState={setEditState}
                loading={loading}
            />

        </div>
    )
}

export default UserList
